// Mock data for the digital product generator

export const productTypes = [
  {
    id: 'carousel',
    name: 'Instagram Carousel',
    description: 'Multi-page Instagram posts that engage and convert',
    icon: 'Images',
    slides: '5-15 slides',
    category: 'social'
  },
  {
    id: 'budget-planner',
    name: 'Budget Planner',
    description: 'Complete budgeting tool with trackers',
    icon: 'Calculator',
    slides: '15-30 pages',
    category: 'planner'
  },
  {
    id: 'workbook',
    name: 'Workbook',
    description: 'Interactive worksheets with exercises and tasks',
    icon: 'FileText',
    slides: '15-40 pages'
  },
  {
    id: 'minicourse',
    name: 'Mini Course',
    description: 'Structured learning program in modules',
    icon: 'GraduationCap',
    slides: '8-20 modules'
  },
  {
    id: 'ebook',
    name: 'E-book',
    description: 'Professional e-books ready to sell',
    icon: 'Book',
    slides: '20-50 pages'
  }
];

export const toneOptions = [
  { value: 'professional', label: 'Professional', description: 'Formal and authoritative' },
  { value: 'friendly', label: 'Friendly', description: 'Warm and accessible' },
  { value: 'motivational', label: 'Motivational', description: 'Inspiring and energetic' },
  { value: 'luxury', label: 'Luxury', description: 'Exclusive and premium' },
  { value: 'casual', label: 'Casual', description: 'Informal and personal' },
  { value: 'educational', label: 'Educational', description: 'Instructive and clear' }
];

export const lengthOptions = [
  { value: 'short', label: 'Short', description: 'Concise and to the point' },
  { value: 'medium', label: 'Medium', description: 'Balanced amount of detail' },
  { value: 'long', label: 'Long', description: 'Thorough and detailed' }
];

export const styleOptions = [
  { value: 'minimal', label: 'Minimalist', description: 'Clean and simple' },
  { value: 'modern', label: 'Modern', description: 'Trendy and fresh' },
  { value: 'elegant', label: 'Elegant', description: 'Sophisticated and stylish' },
  { value: 'playful', label: 'Playful', description: 'Colorful and energetic' },
  { value: 'corporate', label: 'Corporate', description: 'Professional and serious' }
];

export const languageOptions = [
  { value: 'en', label: 'English', flag: '🇬🇧' },
  { value: 'es', label: 'Español', flag: '🇪🇸' },
  { value: 'fr', label: 'Français', flag: '🇫🇷' },
  { value: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { value: 'no', label: 'Norsk', flag: '🇳🇴' },
  { value: 'sv', label: 'Svenska', flag: '🇸🇪' },
  { value: 'da', label: 'Dansk', flag: '🇩🇰' }
];

export const mockGeneratedContent = {
  carousel: {
    title: '5 Signs You Need a Break',
    slides: [
      {
        slideNumber: 1,
        type: 'hook',
        headline: '5 Signs You\nNeed a Break',
        subtext: 'Do any of these sound familiar?',
        notes: 'Hook slide to stop the scroll'
      },
      {
        slideNumber: 2,
        type: 'content',
        headline: '1. You Feel Constantly Tired',
        subtext: 'Even after a full night of sleep, you wake up exhausted',
        notes: 'First sign - relatable for the audience'
      },
      {
        slideNumber: 3,
        type: 'content',
        headline: '2. Little Things Irritate You',
        subtext: 'Your patience is at zero',
        notes: 'Second sign - emotional connection'
      },
      {
        slideNumber: 4,
        type: 'content',
        headline: '3. You Lose Focus',
        subtext: 'Your mind is everywhere except the present moment',
        notes: 'Third sign - cognitive overload'
      },
      {
        slideNumber: 5,
        type: 'content',
        headline: '4. Your Body Sends Signals',
        subtext: 'Headaches, muscle tension, stomachaches',
        notes: 'Fourth sign - physical symptoms'
      },
      {
        slideNumber: 6,
        type: 'content',
        headline: '5. You Forget Self-Care',
        subtext: 'Taking care of yourself ends up last on the list',
        notes: 'Fifth sign - self-care neglect'
      },
      {
        slideNumber: 7,
        type: 'engagement',
        headline: 'Did You Relate?',
        subtext: 'Save this post as a reminder\nto prioritize yourself',
        notes: 'Engagement slide - ask for saves'
      },
      {
        slideNumber: 8,
        type: 'cta',
        headline: 'Take a Break Today',
        subtext: 'You deserve it',
        notes: 'Call-to-action - soft close'
      }
    ],
    caption: '5 signs your body is begging for a break\n\nWe live in a culture where being constantly busy is seen as a positive thing. But your body is trying to tell you something.\n\nIf you recognize yourself in several of these signs, it is time to stop and prioritize yourself.\n\nYou cannot pour from an empty cup. Take care of you.\n\n---\n\nDo you have other signs you recognize? Share in the comments!',
    hashtags: '#selfcare #mentalhealth #breaktime #wellbeing #burnout #balance #selflove #mindfulness #health #wellness'
  },
  guide: {
    title: 'The Ultimate Self-Care Guide',
    pages: [
      { pageNumber: 1, title: 'Introduction', content: 'Welcome to your self-care journey...' },
      { pageNumber: 2, title: 'Why Self-Care Matters', content: 'Self-care is not selfish...' },
      { pageNumber: 3, title: 'Daily Self-Care Routines', content: 'Start with small steps...' }
    ]
  }
};

export const mockTestimonials = [
  {
    name: 'Sarah K.',
    role: 'Digital product sor',
    content: 'I created 5 digital products in under an hour. This tool has completely changed the way I work!',
    rating: 5
  },
  {
    name: 'Maria S.',
    role: 'Content creator',
    content: 'The quality of AI-generated content is better than what I wrote manually. Worth every penny!',
    rating: 5
  },
  {
    name: 'Erik H.',
    role: 'Online coach',
    content: 'I went from spending 3 hours on a guide to 10 minutes. Absolutely amazing!',
    rating: 5
  }
];
